import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Route is /account (index): it redirects to the profile subpage, the default account
 * landing. The account layout has no content of its own; every account surface is a
 * subpage, so the bare /account path forwards to the first one.
 */
export const Route = createFileRoute("/_app/account/")({
  beforeLoad: () => {
    throw redirect({ to: "/account/profile" });
  },
});
